import styled from "styled-components";

export const StyledButton = styled.button`
  border: none;
  outline: none;
  background: #3060e5;
  padding: 12px 24px;
  border-radius: 24px;
  color: #fff;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  height: 56px;

  :hover {
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.1) 100%
      ),
      #3e6df1;
  }

  :active {
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.2) 100%
      ),
      #3e6df1;
    outline: none;
    border: none;
  }
  :focus {
    outline: none;
    border: none;
  }

  :disabled {
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.7) 0%,
        rgba(255, 255, 255, 0.7) 100%
      ),
      #3e6df1;
    cursor: not-allowed;
  }
`;
